import { c7 } from "./c7-hook";
import C7Collection from "./c7-collection";
import C7ProductDetails from "./c7-product-details";
import C7Personalization from "./c7-personalization";
import C7AddToCart from "./c7-add-to-cart";
export default function C7Init() {
    this.init = () => {
        new C7Collection().init();
        new C7ProductDetails().init();
        new C7Personalization().init();
        new C7AddToCart().init();
    };
}